import React from 'react'
import Card from './Card'

function Container({data}) {
  return (
    <div style={{height:"100vh"}}>
        <Card data={data}> </Card>
    </div>
  )
}

export default Container